<template>
    <router-view></router-view>
  <!-- 기본 리스트형 -->
  <div class="lsit_box" v-if="postlists.data">   

    <!-- 항목 테이블 -->
    <div class="posts_wrap" >     
      <template v-if="postlists.data.length ===0">
          <tr><td colspan="6">해당 게시글이 없습니다.</td></tr>
          
      </template>
      <template v-else>    
       
          <div v-for="(list, index) in postlists.data" :key="index" 
          :class="{'notice':list.notice===1}" class="post_block"
          @click="updateCount(list.id, list.document)"
          >           
            <div class="left_part">
              <div class="subject">
                [{{list.document.title}}]
                <span v-if="list.notice===1" class="notice_text">[공지]</span>
                {{list.title}}
              </div>
              <div class="writer"> {{list.user.nic}}</div>
              <div class="time_count">
                <span><display-time :time="list.created_at"/></span>
                <span><font-awesome-icon :icon="['fas', 'eye']" /> {{list.count}}</span>
                <span><font-awesome-icon :icon="['fas', 'heart']" /> {{list.recommend}}</span>
              </div>
            </div>

            <div class="thumb_comment">
              <div class="thumb">
                <post-content :post="list" imgheight="56px" imgwidth="56px" radius="5" :isMobile="true" :titleview="false"/>
              </div>
              <div class="comment">
                <span>{{list.comment}}</span>
                <span>댓글</span>
              </div>
            </div>            
          </div>   
        </template>

 
      <div class="paginate">
       
        <paginate v-if="document" store="posts" collection="postsdata" :document="document" totalvisible="5" :isMobile="true" />
        <paginate-public v-else store="posts" collection="postsdata"  @paging="fetchLists" :isMobile="true"/>
      </div>
    </div>
    <!-- 항목 테이블 -->

  </div>
</template>

<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/Paginate.vue'
import PostContent from '@/components/posts/PostContent.vue'
import { auth } from '@/components/mixins/auth.js';
import { postLink } from '@/utils/menu';
import PaginatePublic from '@/components/site/parts/PaginatePublic.vue';
export default {
  name:'mobile_postlist',
  props:{
    document:{default:null},
    searchview: {
        //type: Array,
        required: false,
        default: false
    },
  },
  mixins:[ auth ],
  components:{
    DisplayTime,
    Paginate,   
    PostContent,
    PaginatePublic
  }, 
  mounted() {
    this.fetchLists();
    //alert(this.$store.state.menu.activeMenu);
  },
  computed:{
    postlists:{
      get(){
        console.log('포스터 데이터 넘어오는 형식 보기',this.$store.state.posts.postsdata)
        return this.$store.state.posts.postsdata;
      }
    },
    postview(){
      return this.$route.fullpath + '/view/';
    },
    isNotice(){
      //공지사항인지 체크, 유저는 글 작성 못하게하 글쓰게 메뉴 안보이게
      if(this.$store.state.menu.activeSubMenu === "notice")
      {
        return true;
      }else{
        return false;
      }     
    }
  },
  methods:{
    async fetchLists() {
      const formData = {
        document: this.document,
        menu:this.$store.state.menu.activeMenu,
        user_id:this.$store.getters.currentUser.id,
        getmypost:false,
        page:1
       }
      try {
          const response = await this.$store.dispatch("posts/fetchLists", formData)
          //console.log(response);
          this.postlists = response.data.reverse();
          //console.log("안나오는듯",this.postlists.data.length);          
      }catch(error){
          console.log(error.response);
      }
      this.isLoading = false;
    },
    async linkWrite(){
      //아이템 필요한 게시판 체크    
      //조아판 카테고리 게시판은 아이템이 있어야 작성가능
      //const needItemPost =['newgame','infomation','gallery_knowhow'];
      // if(needItemPost.indexOf(this.document) > 0) 게시판 위주로 가게 되면 사용 일단은 메뉴로
      if(this.$store.state.menu.activeMenu === "JoaPan")  
      {
        const ckitem =  await this.ckItem('post_write');
        if(!ckitem){  
          return;                          
        }            
      }     
        this.$router.push({
          path: "/main/community/" + this.document +"/write"
        });
    },
    updateCount(list_id,document){            
      const menu = this.$store.getters['menu/getMenu'].find((menu)=>menu.title === document.menu).name;           
      postLink(list_id,menu,document.name,this.$store);   
      
      let routeurl = `/m/community/${menu}/${document.name}/view/${list_id}`
      if(this.searchview)
      {            
        routeurl = `/m/community/postsearch/view/${list_id}`             
      }       
      this.$router.push(routeurl);  
      
      this.$emit('scroll-to-top');         
    }
  }
};
</script>

<style lang="scss" scoped>
.lsit_box {
    font-size: 12px;   
    margin-bottom:200px;
  .posts_wrap {
      padding: 10px 10px 0;
      background:#fff;
      min-height:660px;
      .post_block{
        display: flex;
        justify-content: space-between;
        border-bottom:1px solid #f2f2f2;
        padding:10px 0;
        .left_part{    
          width: calc(100% - 110px);       
           overflow: hidden;
           .subject{    
            
            overflow: hidden;         
            line-height: 19px;           
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 3px; 
          }
          .writer{

          }
          .time_count{
            display: flex;
            margin-top:3px;
            span{
              display: inline-block;
              padding-right: 5px;
            }
          }
        }
        .thumb_comment{
          display: flex;
          .comment{
            margin-left:3px;
            background:#f5f6f8;
            border-radius:5px;
            padding:10px;
            span{
              display:block;
              text-align: center;
              font-size:11px;
              color:#999;
            }
            span:first-child{
              color:#000;
              font-weight: bold;
              margin:5px 0;
            }
          }
        }
       
      }
      .notice{       
        font-weight:bold; 
        .notice_text{
          color:red;
        }
      }
      .article_title,
      .article_writer {
        color: #000;
        font-weight: normal;
      }

      .txt-left {
        text-align: left !important;
      }
  }
  .paginate{
    padding:20px 0 ;
  }
  
}
</style>
